import { useSelector } from 'react-redux';
import { B2xUserAccountType } from 'src/redux/reducers/mainReducer';
import { RootState } from 'src/redux/reducers/rootReducer';
import { useEnv } from './useEnv';

// TODO: Remove this hook, use useUpgradeAccountStatus instead
export const useAccountApproved = () => {
  const accountType = useSelector(
    (state: RootState): string => state.main.b2xUser.account_type,
  );
  const { isProdEnv } = useEnv();
  // The account type in staging env is always marked as APPROVED.
  const isAccountApproved = isProdEnv
    ? accountType === B2xUserAccountType.APPROVED
    : true;

  return isAccountApproved;
};
